import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr6 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа с ръчни електрически инструменти, преносими лампи и захранващи
        устройства
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Лицата, които работят с ръчни електрически инструменти</b> трябва да са преминали
        съответно обучение и инструктаж за безопасна работа и да притежават не по-ниска от втора
        квалификационна група по безопасност на труда.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Задължително да се работи</b> само с изправни и проверени електрически инструменти,
        преносими лампи и захранващи устройства.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни и нестандартни ръчни електрически инструменти.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Номиналното напрежение на преносимите лампи</b> (в зависимост от характеристиката на
        средата по отношение на опасността от поражение от електрически ток) не трябва да надвишава:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - 42 V за среда с нормална опасност;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - 24 V за среда с повишена и особена опасност;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - 12 V в метални резервоари, котли, тунели и др.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - допуска се напрежение 220 V за защитно изолирани преносими лампи (клас II) в среда с
          повишена и особена опасност, ако захранващият кабел не е по-дълъг от 10 метра.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Номиналното напрежение на ръчните инструменти</b> и преносими трансформатори (в
        зависимост от характеристиката на средата по отно- шение на опасността от поражение от
        електрически ток) не трябва да надвишава:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - 220 V за среда без повишена опасност;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - 42 V за среда с повишена и особена опасност;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - 24 V в метални резервоари, котли, тунели и др.
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          {' '}
          - 220 V за защитно изолирани инструменти и трансформатори (клас II)
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. По време на работа захранващите кабели </b>да се пазят от механични повреди на
        изолацията (притискане, прегъване, опъване, допир до нагрети или омаслени повърхности или до
        части с остри, режещи ръбове).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. След приключване на работа </b>или прекъсване на електрическото захранване
        инструментите да се изключват.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          8. <span style={styles.warning}>Забранява се </span>
        </b>
        изключване от захранването чрез дърпане на кабелите.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. Пренасянето на електроинструментите </b>от едно работно място на друго да става при
        изключено напрежение от щепсела.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. При констатиране на неизправност</b> в електроинструментите или в захранващите
        кабели, работата с тях се спира.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Дължината на кабелите на ръчните инструменти </b>да не надвишава 6 т. Допуска се
        дължина до 30 т при използване на защитно изключване или при участие на второ лице като
        наблюдател.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. Дължината на изходящите кабели на захранващите устройства </b>да не надвишава 30 т.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          13. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с електрически инструменти на височина по- голяма от 2,5 m върху преносима стълба.
      </Typography>

      <Typography>
        <b>
          <span style={styles.warning}>14. Забранява се </span>
        </b>
        работа с преносими лампи без защитен екран, предпазна решетка или разсейвател.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15. На работещите с електрически инструменти</b>, по време на работа се
        <span style={styles.warning}>забранява:</span>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да докосват с ръка режещия инструмент, когато е в движение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да заменят режещия инструмент преди пълното му спиране от дви- жение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да отстраняват с ръка стружки или стърготини от режещия инстру- мент, преди пълното му
          спиране.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          16. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с ръчни електрически инструменти вън от помещенията при валеж, и при активна
        атмосферна(гръмотевична) дейност.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>17. Изправността на ръчните електрически инструменти</b>, преносими електрически лампи и
        захранващи устройства да се следи и записва в специален дневник.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>18. Да се работи с ел. инструменти</b>, които са преминали ежемесечен преглед за
        изправност.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>19. Електрическите инструменти да се съхраняват</b> в сухи помещения.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>20. Да не се допуска до работа с ръчни електрически инструменти </b>
        лица употребили алкохол, други упойващи вещества или общо нарушено здравно състояние.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr6;
